import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_FAILED,
  EDIT_SETTINGS,
  CLEAR_SETTINGS_ERROR
} from "../store/types";

import store from '../store/store';
import { getSupabase } from '../config/configureSupabase';

const defaultSettings = {
  appName: "Alpha Giro",
  CompanyName: "Alpha Giro",
  CompanyWebsite: "https://alphagiro-fleet-web.pages.dev",
  CompanyAddress: "Minas Gerais, Brasil",
  CompanyPhone: "+55 31 99999-9999",
  CompanyTerms: "",
  code: "BRL",
  symbol: "R$",
  decimal: 2,
  bonus: 0,
  panic: "190",
  Otp_verify: false,
  email_verify: false,
  license_image_required: false,
  carType_required: false,
  term_required: false,
  realtime_drivers: true
};

export const fetchSettings = () => async (dispatch) => {
  dispatch({
    type: FETCH_SETTINGS,
    payload: null,
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      const { data, error } = await supabase.from('settings').select('*').limit(1).maybeSingle();
      if (!error && data) {
        dispatch({
          type: FETCH_SETTINGS_SUCCESS,
          payload: { ...defaultSettings, ...data },
        });
        return;
      }
    } catch (e) {}
  }

  dispatch({
    type: FETCH_SETTINGS_SUCCESS,
    payload: defaultSettings,
  });
};

export const editSettings = (settings) => async (dispatch) => {
  dispatch({
    type: EDIT_SETTINGS,
    payload: settings
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      await supabase.from('settings').upsert({ id: 1, ...settings });
    } catch (e) {}
  }
};

export const clearSettingsViewError = () => (dispatch) => {
  dispatch({
    type: CLEAR_SETTINGS_ERROR,
    payload: null
  });
};